export default __webpack_public_path__ + "static/media/100.05ca86c4.jpeg";